module.exports = {"TXTWCL_Suggested_amounts":{"id":"TXTWCL_Suggested_amounts","defaultMessage":"Προτεινόμενα ποσά","track":"Suggested amounts"}}